// extracted by mini-css-extract-plugin
module.exports = {"backgroundGrid":"commonHero_backgroundGrid__EuGfN","backgroundGridBlue":"commonHero_backgroundGridBlue__VRxB_"};